module.exports = __webpack_public_path__ + "img/cmdb4.0e5c674a.png";